<template>
  <div class="bg-[#FAFAFA]">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>
